class ToCart {
    constructor(element) {
        this.button = element;
        this.type = null;

        this.init();
        this.bind();
    }

    init() {
        this.wrapper = this.button.closest('[data-to-cart-wrapper]');
        if (this.wrapper) {
            this.type = this.wrapper.dataset.type;
            this.input = this.wrapper.querySelector('[data-quantity-input]');
            this.externalId = this.button.dataset.externalId;
        }
    }

    bind() {
        const instance = this;
        console.log(this.button)

        this.button.addEventListener('click', (e) => {
            console.log(['catalog', 'regular-slider', 'profile-regular', 'product-page'].includes(instance.type))

            e.preventDefault();
            if (['catalog', 'regular-slider', 'profile-regular', 'product-page'].includes(instance.type)) {
               instance.defaultHandle(instance.type);
            }
        });
    }

    defaultHandle(type) {
        this.button.classList.add('_success');
        const quantity = this.input.value;
        const productId = this.externalId;
        document.dispatchEvent(new CustomEvent('add-basket-item',
            {detail: { productId, quantity }}
        ));

        this.input.dispatchEvent(new CustomEvent('restart'));
        setTimeout(() => {
            this.button.classList.remove('_success');
        }, 2000);

        document.dispatchEvent(new CustomEvent('update-product-counts'));

        if (['catalog', 'profile-regular'].includes(type)  && window.innerWidth >= 1280) {
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('openModalBasket', { detail: { productId, quantity}}))
            }, 300)
        }
    }
}


function findButtons() {
    document.querySelectorAll('[data-to-cart-button]:not([data-initialized="true"])')
        .forEach((element) => {
            element.dataset.initialized = "true";
            new ToCart(element);
        });
}

document.addEventListener('DOMContentLoaded', findButtons);
document.addEventListener('DOMContentMutated', findButtons);